<template>
  <span class="required-field" style="color: red"> *</span>
</template>
<script>
export default {
  name: "RequiredSpan",
};
</script>
